import React from "react";
import { AspectRatio } from "@chakra-ui/react";
import { FillImage } from "components/images";
import { type ImageProps } from "next/image";

export function PhotoBlock(imageProps: ImageProps) {
  return (
    <AspectRatio
      ratio={1}
      w="100%"
      maxW={{ base: "100%", sm: "500px", xl: "100%" }}
      boxShadow="md"
      borderRadius="bigger"
      overflow="hidden"
      ml={{ base: "20px", sm: "32px", lg: "40px", xl: "60px" }}
      mr={{ base: "12px", sm: "32px", lg: "30px", xl: "0" }}
    >
      <FillImage priority {...imageProps} />
    </AspectRatio>
  );
}
